module.exports = __webpack_public_path__ + "static/img/pottery_share.6eb0395.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/pottery_share.jpg
// module id = SpHu
// module chunks = 26